import React from 'react';
import {Typography} from '~library/atoms/Typography';
import {FontItem} from '~/common/fabric/CreateDesign/components/CardEditor/actions/Dropdown/FontItem/FontItem';
import {RECOMMENDED_FONTS} from '~/common/fabric/CreateDesign/constants';
import './RecommendedFonts.sass';

export const RecommendedFonts = ({onChange, selectedFont}) => (
  <div>
    <Typography as="p" variant="paragraph4" size="medium" classNames="recommended_fonts__title">
      RECOMMENDED FONTS
    </Typography>

    {RECOMMENDED_FONTS.map((font) => (
      <FontItem
        onClick={onChange}
        font={font}
        key={font.name}
        selected={selectedFont?.name === font?.name}
      />
    ))}
  </div>
);
